import React from 'react';

export interface TableAction {
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
  variant: 'edit' | 'delete' | 'secondary';
  disabled?: boolean;
}

interface TableActionButtonsProps {
  actions: TableAction[];
}

const variantStyles = {
  edit: 'text-amber-400 hover:bg-amber-500/20 hover:text-amber-300',
  delete: 'text-red-400 hover:bg-red-500/20 hover:text-red-300',
  secondary: 'text-gray-400 hover:bg-rs-surfaceLight hover:text-gray-200',
};

export default function TableActionButtons({ actions }: TableActionButtonsProps) {
  return (
    <div className="flex items-center gap-1">
      {actions.map((action, i) => (
        <button
          key={i}
          type="button"
          title={action.label}
          onClick={action.onClick}
          disabled={action.disabled}
          className={`
            p-2 rounded-lg transition-all duration-200
            disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-transparent
            ${variantStyles[action.variant]}
          `}
        >
          {action.icon}
        </button>
      ))}
    </div>
  );
}

const EditIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
  </svg>
);

const DeleteIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
  </svg>
);

const InactivateIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
  </svg>
);

const ActivateIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
);

export { EditIcon, DeleteIcon, InactivateIcon, ActivateIcon };
